// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";

function footer_link_mapper(title, link) {
  return {
          title: title,
          link: link
        };
}

function getLinkLabelVm(data) {
  return {
          link: data.link,
          label: data.label
        };
}

function getLinkIconPairsVm(data) {
  return $$Array.map((function (linkIcon) {
                return {
                        icon: linkIcon.icon,
                        link: linkIcon.link
                      };
              }), data);
}

function getLinkLabelPairsVm(data) {
  return {
          title: data.title,
          link_label_pairs: $$Array.map(getLinkLabelVm, data.link_label_pairs)
        };
}

function getLinkLabelPairsListVm(data) {
  return $$Array.map(getLinkLabelPairsVm, data);
}

function getAppIconVm(app_store, play_store) {
  return {
          play_store_icon: play_store,
          app_store_icon: app_store
        };
}

function getSocialMediaLinksVm(data) {
  return $$Array.map((function (link) {
                return {
                        icon: data.logo,
                        link: link.link
                      };
              }), data.social_media_links);
}

function getLinksListVm(data) {
  return {
          service_links_list: $$Array.map(getLinkLabelPairsVm, data.service_links_list),
          city_links_list: getLinkLabelPairsVm(data.city_links_list),
          social_links: getSocialMediaLinksVm(data.social_links)
        };
}

function getCopyrightLabels(copyrightLabels) {
  return $$Array.map((function (label) {
                return label.label;
              }), copyrightLabels);
}

function getVm(data) {
  return {
          title: data.title,
          logo: data.logo,
          company_info: data.company_info,
          app_icons: {
            play_store_icon: data.play_store_icon,
            app_store_icon: data.app_store_icon
          },
          linksList: getLinksListVm(data),
          copyrightLabels: $$Array.map((function (label) {
                  return label.label;
                }), data.copyrightLabels)
        };
}

var ztp_pdf_link = "https://drive.google.com/viewerng/viewer?embedded=true&url=https://dom-website-prod-cdn-web.porter.in/zero_tolerance_policy.pdf";

export {
  ztp_pdf_link ,
  footer_link_mapper ,
  getLinkLabelVm ,
  getLinkIconPairsVm ,
  getLinkLabelPairsVm ,
  getLinkLabelPairsListVm ,
  getAppIconVm ,
  getSocialMediaLinksVm ,
  getLinksListVm ,
  getCopyrightLabels ,
  getVm ,
}
/* No side effect */
